import { AlertComponentTheme, AlertComponentType } from './alert.type'

export const AlertComponentThemes: Record<AlertComponentType, AlertComponentTheme> = {
  error: {
    icon: 'error_outline',
    color: 'color-danger',
  },
  success: {
    icon: 'check_circle',
    color: 'color-success',
  },
  warning: {
    icon: 'error_outline',
    color: 'color-warning',
  },
  info: {
    icon: 'info',
    color: 'color-primary',
  },
}
